import React, { useState, useEffect } from "react";
import useStyles from "../styles";
import { useLocation, useHistory } from "react-router-dom";
import config from "../../../config";
import axios from "axios";

// components
import InputComponent from "../../partner/components/inputComponent";
import InputSelect from "../../partner/components/inputSelect";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import InputDecimal from "../../partner/components/inputDecimal";
import InputDisableAge from "./inputDisableAge";
import InputDisableSimpleText from "./inputDisableSimpleText";
import SwitchToUseGym from "./switch";
import { TextField } from "@material-ui/core";
import { Edit, Delete, RefreshRounded } from "@material-ui/icons";
import Modal from "../../modals/Modal";
import SimpleImageInput from "./simpleImageInput";
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function UserInfo() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    }

    const classes = useStyles();
    const location = useLocation();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [password, setPassword] = useState({ text: '', valid: null });
    const [name, setName] = useState({ text: '', valid: null });
    const [lastName, setLastName] = useState({ text: '', valid: null });
    const [birthdayDate, setBirthdayDate] = useState('');
    const [birthdayValue, setBirthdayValue] = useState('');
    const [age, setAge] = useState('Edad');
    const [address, setAddress] = useState({ text: '', valid: null });
    const [image, setImage] = useState(null);
    const [email, setEmail] = useState({ text: '', valid: null });
    const [phone, setPhone] = useState({ text: '', valid: null });
    const [rightToUseGym, setRightToUseGym] = useState(false);
    const [rightToUseGymFetch, setRightToUseGymFetch] = useState(false);
    const [userStatus, setUserStatus] = useState({ text: '', valid: null });
    const [gender, setGender] = useState({ text: '', valid: null });
    const [card, setCard] = useState({ text: '', valid: null });
    const [job, setJob] = useState({ text: '', valid: null });
    const [userType, setUserType] = useState({ text: '', valid: null });
    const [checkIn, setCheckIn] = useState('00:00');
    const [checkOut, setCheckOut] = useState('00:00');
    const [salary, setSalary] = useState({ text: '', valid: null });
    const [paymentMethod, setPaymentMethod] = useState({ text: '', valid: null });
    const [paymentPeriod, setPaymentPeriod] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const [principalImage, setPrincipalImage] = useState(null);
    const [fingerPrint, setFingerPrint] = useState({ text: '', valid: null });
    const [autocompleteKey, setAutocompleteKey] = useState(0);

    const [userInfo, setUserInfo] = useState([]);
    const [allUserStatus, setAllUserStatus] = useState([]);
    const [allGenders, setAllGenders] = useState([]);
    const [allUserType, setAllUserType] = useState([]);
    const [allJobs, setAllJob] = useState([]);
    const [allPaymentMethod, setAllPaymentMethod] = useState([]);
    const [allPaymentPeriod, setAllPaymentPeriod] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingToSaveUser, setIsLoadingToSaveUser] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [allFingerPrints, setAllFingerPrints] = useState([]);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    function getLabel(value) {
        if (value == null || value == '') {
            return '';
        }

        var day = value.toString().substring(8);
        var month = value.toString().substring(5, 7);
        var year = value.toString().substring(0, 4);

        return year + '-' + month + '-' + day;
    }

    const fetchUserInfo = async () => {
        var id = '';

        try {
            if (location.state.id == null) {
                id = location.state.id;
            } else {
                id = localStorage.getItem('userInfo');
            }
        } catch (e) {
            id = localStorage.getItem('userInfo');
        }

        fetch(baseUrl + "userById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setUserInfo(data);
                    setPassword({ text: data.password, valid: 'true' });
                    setName({ text: data.name, valid: 'true' });
                    setLastName({ text: data.lastName, valid: 'true' });
                    setBirthdayDate(data.birthdayDate);
                    setBirthdayValue(getLabel(data.birthdayDate));
                    setAge(data.age);
                    setAddress({ text: data.address, valid: 'true' });
                    setImage(data.image);
                    setEmail({ text: data.email, valid: 'true' });
                    setPhone({ text: data.phone, valid: 'true' });
                    setRightToUseGym(data.rightToUseGym == 1 ? true : false);
                    setRightToUseGymFetch(data.rightToUseGym == 1 ? true : false);
                    setUserStatus({ text: data.userStatus, valid: 'true' });
                    setGender({ text: data.gender, valid: 'true' });
                    setCard({ text: data.card, valid: 'true' });
                    setJob({ text: data.job, valid: 'true' });
                    setUserType({ text: data.userType, valid: 'true' });
                    setCheckIn(data.checkIn);
                    setCheckOut(data.checkOut);
                    setSalary({ text: data.salary, valid: 'true' });
                    setPaymentMethod({ text: data.paymentMethod, valid: 'true' });
                    setPaymentPeriod({ text: data.paymentPeriod, valid: 'true' });
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);

                    setIsLoading(false);
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchFingerPrints = async () => {
        if (!showModal) {
            fetch(baseUrl + "getTemplates",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error != null) {
                        setShowModal(true);
                    } else {
                        setAllFingerPrints(data);
                    }
                })
                .catch(error => null);
        }
    }

    const fetchGenders = async () => {
        if (!showModal) {
            fetch(baseUrl + "genders",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllGenders(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchGenericStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllUserStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchUserType = async () => {
        if (!showModal) {
            fetch(baseUrl + "userType",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllUserType(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchJob = async () => {
        if (!showModal) {
            fetch(baseUrl + "job",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllJob(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchPaymentMethod = async () => {
        if (!showModal) {
            fetch(baseUrl + "paymentMethod",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllPaymentMethod(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchPaymentPeriod = async () => {
        if (!showModal) {
            fetch(baseUrl + "paymentPeriod",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllPaymentPeriod(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchUserInfo();
        fetchFingerPrints();
        fetchGenders();
        fetchGenericStatus();
        fetchUserType();
        fetchJob();
        fetchPaymentMethod();
        fetchPaymentPeriod();
    }, [location]);

    const handleCheckInChange = (event) => {
        setCheckIn(event.target.value);
    };

    const handleCheckOutChange = (event) => {
        setCheckOut(event.target.value);
    };

    const onChangeDatePicker = (e) => {
        setBirthdayDate(e.target.value);

        var today = new Date();
        var birthDate = new Date(e.target.value);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        setAge(age);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSaveUser(true);

        if (password.valid === 'true' && name.valid === 'true' && lastName.valid === 'true' && email.valid === 'true'
            && phone.valid === 'true' && userStatus.valid === 'true' && gender.valid === 'true'
            && card.valid === 'true' && job.valid === 'true' && userType.valid === 'true'
            && salary.valid === 'true' && paymentMethod.valid === 'true' && paymentPeriod.valid === 'true') {
            const formData = new FormData();

            if (principalImage != null) formData.append("file", principalImage);
            formData.append("idUser", userInfo.id);
            formData.append("name", name.text);
            formData.append("lastName", lastName.text);
            formData.append("birthdayDate", birthdayDate);
            formData.append("age", age == 'Edad' ? 0 : age);
            formData.append("password", password.text);
            formData.append("address", address.text);
            formData.append("email", email.text);
            formData.append("phone", phone.text);
            formData.append("rightToUseGym", rightToUseGym == true ? 1 : 0);
            formData.append("gender", gender.text);
            formData.append("job", job.text);
            formData.append("userType", userType.text);
            formData.append("checkIn", checkIn);
            formData.append("checkOut", checkOut);
            formData.append("salary", salary.text);
            formData.append("paymentMethod", paymentMethod.text);
            formData.append("paymentPeriod", paymentPeriod.text);
            formData.append("userStatus", userStatus.text);
            if (fingerPrint.text != null && fingerPrint.text != '') formData.append("fingerPrint", fingerPrint.text);

            await axios({
                method: "put",
                url: baseUrl + "updateUser",
                data: formData,
                headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
            })
                .then(function (response) {
                    if (response.data.message == "Ok") {

                    } else {
                        if (response.data.message == "Access is denied") {
                            setShowModal(true);
                        }
                    }
                })
                .catch(function (response) { });

            setDisableInpunts(!disableInpunts);
            setFingerPrint({ text: '', valid: null });
            setAutocompleteKey(autocompleteKey + 1);
            setIsLoadingToSaveUser(false);
        } else {
            setIsLoadingToSaveUser(false);
        }
        fetchUserInfo();
    }

    const onDelete = async e => {
        e.preventDefault();
        setIsLoadingToSaveUser(true);

        const response = await fetch(baseUrl + "deleteUser/" + userInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.setItem('userInfo', '');
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveUser(false);
    }

    const onTagsChange = (event, values) => {
        if (values != null) {
            setFingerPrint({ text: values.template, valid: "true" });
        } else {
            setFingerPrint({ text: '', valid: "false" });
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <div className={classes.titleRow}>
                <PageTitle title="Información del usuario" />

                {isLoading ? (
                    <></>
                ) : (
                    <>
                        {userInfo.id == 1 ? (
                            <></>
                        ) : (
                            <>
                                <div className={classes.marginAuto} />
                                <div className={classes.divActionButton} >
                                    <Edit classes={{ root: classes.searchIcon }}
                                        onClick={() => {
                                            setDisableInpunts(!disableInpunts);
                                        }}
                                    />
                                </div>
                                <div className={classes.divActionButtonDisable} >
                                    <Delete
                                        classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                        onClick={!disableInpunts ? null : onDelete}
                                    />
                                </div>
                            </>
                        )}

                    </>
                )}
            </div>

            <div className={classes.divCard} >
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <div className={classes.divColumn} >
                        <InputComponent
                            text={name}
                            setPartnerCode={setName}
                            type="text"
                            label="Nombres"
                            name="name"
                            regularExpression={expressions.nombre}
                            placeholder="Nombre"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={lastName}
                            setPartnerCode={setLastName}
                            type="text"
                            label="Apellidos"
                            name="lastName"
                            regularExpression={expressions.nombre}
                            placeholder="Apellidos"
                            isEnable={disableInpunts}
                        />

                        <div className={classes.divDate}>
                            <label className={classes.labelDate} >Fecha de nacimiento</label>
                            <TextField
                                type="date"
                                defaultValue={birthdayValue}
                                className={classes.inputDate}
                                onChange={onChangeDatePicker}
                                style={{ width: '85%' }}
                                disabled={disableInpunts}
                                inputStyle={{ width: '85%' }}
                            />
                        </div>

                        <InputDisableAge
                            value={age}
                            type="text"
                            label="Edad"
                            name="age"
                            placeholder="18 años"
                        />

                        {!disableInpunts ? (
                            <SimpleImageInput
                                text={principalImage}
                                setValue={setPrincipalImage}
                                label={"Foto del usuario"}
                            />
                        ) : (
                            <div style={{ width: "200px", height: "240px", marginBottom: "30px" }}>
                                <p className={classes.label} >Foto del usuario</p>
                                {image != null ? (
                                    <img
                                        src={baseUrl + "userImage/" + image}
                                        alt=""
                                        height={200}
                                        width={200}
                                    />
                                ) : (
                                    <div style={{
                                        height: "200px", width: "200px", backgroundColor: "#021D61", borderRadius: "4px"
                                    }}>
                                    </div>
                                )}
                            </div>
                        )}

                        <InputSelect
                            text={gender}
                            setValue={setGender}
                            label={"Género"}
                            options={allGenders}
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={phone}
                            setPartnerCode={setPhone}
                            type="text"
                            label="Teléfono"
                            name="phone"
                            regularExpression={expressions.numbers}
                            placeholder="6688888888"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={email}
                            setPartnerCode={setEmail}
                            type="text"
                            label="Correo electrónico"
                            name="email"
                            regularExpression={expressions.email}
                            placeholder="correo@ejemplo.com"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={password}
                            setPartnerCode={setPassword}
                            type="text"
                            label="Contraseña"
                            name="password"
                            regularExpression={expressions.password}
                            placeholder="contraseña"
                            isEnable={disableInpunts}
                        />

                        <InputComponent
                            text={address}
                            setPartnerCode={setAddress}
                            type="text"
                            label="Dirección"
                            name="address"
                            regularExpression={expressions.texto}
                            placeholder="Calle primera, 1234, Centro"
                            isEnable={disableInpunts}
                        />

                        <div className={classes.divHeader} >
                            <div className={classes.searchDivFullWidthWithoutShadow} >
                                <Autocomplete
                                    key={autocompleteKey}
                                    options={allFingerPrints}
                                    getOptionLabel={option => option.code}
                                    onChange={onTagsChange}
                                    className={classes.inputSearchFinger}
                                    openText={"Abrir"}
                                    closeText={"Cerrar"}
                                    clearText={"Limpiar"}
                                    noOptionsText={"Sin resultados"}
                                    disabled={disableInpunts}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            placeholder={"Buscar huella digital"}
                                            fullWidth
                                        />
                                    )}
                                />

                                {disableInpunts ? (
                                    <></>
                                ) : (
                                    <>
                                        <div className={classes.divActionButton}>
                                            <RefreshRounded className={classes.iconAcctionInventory}
                                                onClick={fetchFingerPrints}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <InputSelect
                            text={userType}
                            setValue={setUserType}
                            label={"Tipo de usuario"}
                            options={allUserType}
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={job}
                            setValue={setJob}
                            label={"Puesto"}
                            options={allJobs}
                            isEnable={disableInpunts}
                        />

                        <div className={classes.row}>
                            <div className={classes.divDate}>
                                <label className={classes.labelDate} >Hora de entrada</label>
                                <TextField
                                    id="time"
                                    type="time"
                                    defaultValue="00:00"
                                    value={checkIn}
                                    className={classes.textFieldTime}
                                    onChange={handleCheckInChange}
                                    disabled={disableInpunts}
                                    style={{ width: '85%' }}
                                    inputStyle={{ width: '85%' }}
                                />
                            </div>

                            <div className={classes.divDate}>
                                <label className={classes.labelDate} >Hora de salida</label>
                                <TextField
                                    id="time"
                                    type="time"
                                    defaultValue="00:00"
                                    value={checkOut}
                                    className={classes.textFieldTime}
                                    onChange={handleCheckOutChange}
                                    disabled={disableInpunts}
                                    style={{ width: '85%' }}
                                    inputStyle={{ width: '85%' }}
                                />
                            </div>
                        </div>

                        <InputDecimal
                            text={salary}
                            setPartnerCode={setSalary}
                            type="text"
                            label="Sueldo"
                            name="salary"
                            placeholder="100.00"
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={paymentMethod}
                            setValue={setPaymentMethod}
                            label={"Método de pago"}
                            options={allPaymentMethod}
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={paymentPeriod}
                            setValue={setPaymentPeriod}
                            label={"Periodo de pago"}
                            options={allPaymentPeriod}
                            isEnable={disableInpunts}
                        />

                        <SwitchToUseGym
                            value={rightToUseGym}
                            setValue={setRightToUseGym}
                            label="Permiso para usar el gimnasio"
                            isEnable={disableInpunts}
                        />

                        <InputSelect
                            text={userStatus}
                            setValue={setUserStatus}
                            label={"Estado"}
                            options={allUserStatus}
                            isEnable={disableInpunts}
                        />

                        <InputDisableSimpleText
                            value={creationDate}
                            type="text"
                            label="Fecha de alta"
                            name="creationDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />

                        <InputDisableSimpleText
                            value={lastUpdateDate}
                            type="text"
                            label="Última modificación"
                            name="lastUpdateDate"
                            placeholder="Fecha"
                            isPrice={false}
                        />
                    </div>
                )}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSaveUser ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={password.text != userInfo.password || name.text != userInfo.name ||
                                    lastName.text != userInfo.lastName || birthdayDate != userInfo.birthdayDate ||
                                    address.text != userInfo.address || email.text != userInfo.email || phone.text != userInfo.phone ||
                                    userStatus.text != userInfo.userStatus || gender.text != userInfo.gender ||
                                    principalImage != userInfo.image || job.text != userInfo.job || userType.text != userInfo.userType ||
                                    salary.text != userInfo.salary || paymentMethod.text != userInfo.paymentMethod ||
                                    paymentPeriod.text != userInfo.paymentPeriod || rightToUseGym != (rightToUseGymFetch == 1 ? true : false) ||
                                    checkIn != userInfo.checkIn || checkOut != userInfo.checkOut || fingerPrint.text != '' ?
                                    classes.enableButton : classes.disableButton}
                                disabled={!(password.text != userInfo.password || name.text != userInfo.name ||
                                    lastName.text != userInfo.lastName || birthdayDate != userInfo.birthdayDate ||
                                    address.text != userInfo.address || email.text != userInfo.email || phone.text != userInfo.phone ||
                                    userStatus.text != userInfo.userStatus || gender.text != userInfo.gender ||
                                    principalImage != userInfo.image || job.text != userInfo.job || userType.text != userInfo.userType ||
                                    salary.text != userInfo.salary || paymentMethod.text != userInfo.paymentMethod ||
                                    paymentPeriod.text != userInfo.paymentPeriod || rightToUseGym != (rightToUseGymFetch == 1 ? true : false) ||
                                    checkIn != userInfo.checkIn || checkOut != userInfo.checkOut || fingerPrint.text != '')}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
